import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {Dropdown, Menu} from "antd";
import './style.css'
import {useDispatch} from "react-redux";
import moment from "moment";
import {actions} from "../../../store/reducers/lang";
import {actions as userActions} from "../../../store/actions/user";
import ruRU from 'antd/lib/locale/ru_RU'
import byBY from 'antd/lib/locale/by_BY'
import enUs from 'antd/lib/locale/en_US'

type Item = {
    name: string
    lng: string
}

function getMenuItems() {
    return [
        {name: 'Беларускi', lng: 'be'},
        {name: 'Русский', lng: 'ru'},
        {name: 'English', lng: 'en'}
    ] as Array<Item>
}

export default function Lang() {
    const { i18n } = useTranslation()
    const menuItems = getMenuItems()
    const dispatch = useDispatch()

    useEffect(() => {
        moment.locale(i18n.language)
        let locale = getLocale(i18n.language?.substring(0, 2))
        dispatch(actions.setLanguage(locale))
    },[])

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng)
        moment.locale(lng)
        let locale = getLocale(lng)
        dispatch(actions.setLanguage(locale))
        dispatch(userActions.clearUserTypes())
        //closeLangMenu()
    }

    const getLocale = (lang: string) => {
        switch (lang) {
            case 'ru':
                return ruRU
            case 'be':
                return byBY
            case 'en':
                return enUs
            default:
                return ruRU
        }
    }

    const langMenu = (
        <Menu>
            {menuItems.map(n =>
            <Menu.Item
                key={n.name}
                className='languageSelector'
                onClick={() => changeLanguage(n.lng)}
            >
                {n.name}
            </Menu.Item>)}
        </Menu>
    )

    return (
        <div>
            <Dropdown overlay={langMenu}
                      placement="bottomCenter"
                      className='buttonLang'
            >
                <div>
                    {i18n.language?.substring(0, 2).toUpperCase()}
                </div>
            </Dropdown>
        </div>
    )
}

